
const specialCharacters = new RegExp(/[!@#$%^&*()+'‘’"“”:;?[\]<>/.,{}\\=\-|~`]/g);

export function removeBadChars(inputString) {
  return inputString.replace(specialCharacters, '');
}



// WEBPACK FOOTER //
// ./src/data/filters/form-sanitizer.js